import { createSelector } from 'reselect';
import * as addresses from '../../api/countryApi';

const GET_COUNTRIES = 'efes/address/GET_COUNTRIES';
const GET_COUNTRIES_SUCCESS = 'efes/address/GET_COUNTRIES_SUCCESS';
const GET_COUNTRIES_FAIL = 'efes/address/GET_COUNTRIES_FAIL';

const GET_STATES = 'efes/address/GET_STATES';
const GET_STATES_SUCCESS = 'efes/address/GET_STATES_SUCCESS';
const GET_STATES_FAIL = 'efes/address/GET_STATES_FAIL';

const GET_CITY_VILLAGES = 'efes/address/GET_CITY_VILLAGES';
const GET_CITY_VILLAGES_SUCCESS = 'efes/address/GET_CITY_VILLAGES_SUCCESS';
const GET_CITY_VILLAGES_FAIL = 'efes/address/GET_CITY_VILLAGES_FAIL';

const initialState = {
  countries: [],
  states: [],
  cityVillages: [],
  countriesLoading: false,
  statesLoading: false,
  cityVillagesLoading: false,
  error: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_COUNTRIES:
      return {
        ...state,
        countriesLoading: true,
      };
    case GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        countriesLoading: false,
        countries: action.result,
      };
    case GET_COUNTRIES_FAIL:
      return {
        ...state,
        countriesLoading: false,
        error: action.error,
      };

    case GET_STATES:
      return {
        ...state,
        statesLoading: true,
      };
    case GET_STATES_SUCCESS:
      return {
        ...state,
        statesLoading: false,
        states: action.result,
      };
    case GET_STATES_FAIL:
      return {
        ...state,
        statesLoading: false,
        error: action.error,
      };

    case GET_CITY_VILLAGES:
      return {
        ...state,
        cityVillages: [],
        cityVillagesLoading: true,
      };
    case GET_CITY_VILLAGES_SUCCESS:
      return {
        ...state,
        cityVillagesLoading: false,
        cityVillages: action.result,
      };
    case GET_CITY_VILLAGES_FAIL:
      return {
        ...state,
        cityVillagesLoading: false,
        error: action.error,
      };
    default:
      return state;
  }
}

export function getCountries() {
  return {
    actions: [
      { type: GET_COUNTRIES },
      { type: GET_COUNTRIES_SUCCESS },
      { type: GET_COUNTRIES_FAIL, showError: true },
    ],
    promise: addresses.fetchCountries().then((resp) => resp.countries || []),
  };
}

export function getStates() {
  return {
    actions: [
      { type: GET_STATES },
      { type: GET_STATES_SUCCESS },
      { type: GET_STATES_FAIL, showError: true },
    ],
    promise: addresses.fetchStates().then((resp) => resp.raStates || []),
  };
}

export function getCityVillages(id) {
  return {
    actions: [
      { type: GET_CITY_VILLAGES },
      { type: GET_CITY_VILLAGES_SUCCESS },
      { type: GET_CITY_VILLAGES_FAIL, showError: true },
    ],
    promise: addresses.fetchCityVillages(id).then((resp) => resp.citiesVillages || []),
  };
}

export const selectSortedCountries = createSelector(
  (state) => state.countriesReducer.countries,
  (_, language) => language,
  (countries, language) => countries.sort((a, b) => {
    if (a.iso3 === 'ARM') {
      return -1;
    }
    if (b.iso3 === 'ARM') {
      return 1;
    }
    if (a[`name${language.toUpperCase()}`] > b[`name${language.toUpperCase()}`]) {
      return 1;
    }
    if (a[`name${language.toUpperCase()}`] < b[`name${language.toUpperCase()}`]) {
      return -1;
    }
    return 0;
  }),
);
export const selectSortedRAStates = createSelector(
  (state) => state.countriesReducer.states,
  (_, language) => language,
  (states, language) => states.sort((a, b) => {
    if (a.nameEN === 'Yerevan') {
      return -1;
    }
    if (b.nameEN === 'Yerevan') {
      return 1;
    }
    if (a[`name${language.toUpperCase()}`] > b[`name${language.toUpperCase()}`]) {
      return 1;
    }
    if (a[`name${language.toUpperCase()}`] < b[`name${language.toUpperCase()}`]) {
      return -1;
    }
    return 0;
  }),
);
export const selectSortedCityVillages = createSelector(
  (state) => state.countriesReducer.cityVillages,
  (_, language) => language,
  (cityVillages, language) => cityVillages.sort((a, b) => {
    if (a[`name${language.toUpperCase()}`] > b[`name${language.toUpperCase()}`]) {
      return 1;
    }
    if (a[`name${language.toUpperCase()}`] < b[`name${language.toUpperCase()}`]) {
      return -1;
    }
    return 0;
  }),
);
